




















































































































































































































import SearchBuilder from "@/builder/SearchBuilder";
import { debounce, debounceProcess } from "@/helpers/debounce";
import { ResponsePagination } from "@/models/constant/interface/common.interface";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { Messages } from "@/models/enums/messages.enum";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import {
  DataResponseGetStockAdjustment,
  DataWarehouse,
  DataWarehouseBranch,
  DataWarehouseLocation,
} from "@/models/interface/logistic.interface";
import { generalJournalServices } from "@/services/generaljournal.service";
import { logisticServices } from "@/services/logistic.service";
import moment from "moment";
import printJs from "print-js";
import Vue from "vue";

enum STOCK_TYPE {
  STOCK_ADJUSTMENT = "Stock Adjustment",
  STOCK_OPNAME = "Stock Opname",
}

const OPT_TYPE = [
  {
    key: "Stock Adjustment",
    value: STOCK_TYPE.STOCK_ADJUSTMENT,
  },
  {
    key: "Stock Opname",
    value: STOCK_TYPE.STOCK_OPNAME,
  },
];

export default Vue.extend({
  data() {
    this.getBranch = debounceProcess(this.getBranch, 200);
    this.getListWarehouse = debounceProcess(this.getListWarehouse, 200);
    return {
      branchId: "" as string,
      idWarehouse: "" as string,
      dataBranch: [] as DataWarehouseBranch[],
      dataListLocationWarehouse: [] as DataWarehouse[],
      dataListLocationRack: [] as DataWarehouseLocation[],
      modelForm: {
        date: [] as any,
      },
      params: { sorts: "date:asc" } as RequestQueryParamsModel,
      dataSource: [] as DataResponseGetStockAdjustment[],
      columnsTable: [
        {
          title: "Doc Number",
          dataIndex: "documentNumber",
          key: "documentNumber",
          width: 150,
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          width: 150,
        },
        {
          title: this.$t("lbl_location"),
          dataIndex: "warehouseName",
          key: "warehouseName",
          width: 200,
          customRender: (text: string, record: any) =>
            record.branchName && record.warehouseName
              ? `${record.branchName}, ${record.warehouseName}`
              : "-",
        },
        {
          title: "Type",
          dataIndex: "type",
          key: "type",
          width: 150,
        },
        {
          title: "Journal Number",
          dataIndex: "journalNumber",
          key: "journalNumber",
          width: 150,
          scopedSlots: { customRender: "clickColumn" },
        },
        {
          title: "Status",
          dataIndex: "state",
          key: "state",
          width: 150,
        },
      ],
      page: 1 as number,
      totalElements: 0 as number,
      limit: 10 as number,
      loadingTable: false as boolean,
      loadingSubmit: false as boolean,
      loadingDownload: false as boolean,
      loadingPrint: false as boolean,
      loadingBranch: false as boolean,
      loadingLocationWarehouse: false as boolean,
      loadingLocationRack: false as boolean,
      DEFAULT_DATE_FORMAT,
      attachmentFile: "" as string,
      optType: OPT_TYPE,
      dataStockAdjustment: [] as DataResponseGetStockAdjustment[],
      loadingNo: false as boolean,
      stockAdjustmentId: "" as string,
      form: this.$form.createForm(this, { name: "listStockAdjustment" }),
      formRules: {
        no: {
          label: "lbl_document_number",
          name: "No",
          placeholder: "lbl_document_number_placeholder",
          decorator: [
            "no",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        branch: {
          label: "lbl_branch",
          name: "branch",
          placeholder: "lbl_branch_placeholder",
          decorator: [
            "branch",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        warehouse: {
          label: "lbl_warehouse",
          name: "warehouse",
          placeholder: "lbl_warehouse_placeholder",
          decorator: [
            "warehouse",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        rack: {
          label: "lbl_rack",
          name: "rack",
          placeholder: "lbl_rack_placeholder",
          decorator: [
            "rack",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        adj: {
          label: "lbl_adj_type",
          name: "Adj. Type",
          placeholder: "lbl_adj_type_placeholder",
          decorator: [
            "adj",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        date: {
          label: "lbl_date",
          name: "Date",
          placeholder: "lbl_date_placeholder",
          decorator: [
            "date",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
      },
    };
  },
  methods: {
    moment,
    async handleClickColumn(record, objColumnNameValue) {
      let data;
      const paramsJournal = {
        page: 0,
        limit: 10,
        search: `name~${record.journalNumber}`,
        sorts: "createdDate:desc",
      } as RequestQueryParamsModel;
      if (objColumnNameValue.column === "journalNumber") {
        data = await generalJournalServices.listGeneralJournal(paramsJournal);
        if (data.data.length > 0) {
          this.$confirm({
            title: "You will be redirected to another page, are you sure?",
            onOk: () => {
              this.$router.push(
                `/generaljournal/journal/detail/${data.data[0].id}`
              );
            },
            onCancel() {
              return;
            },
          });
        }
      }
    },
    handleDownload() {
      this.form.validateFields((err, res) => {
        if (err) return;
        this.params.params = this.checkParams(res);
        this.params.search = this.dynamicSearch(res);
        if (
          this.modelForm.date &&
          Array.isArray(this.modelForm.date) &&
          this.modelForm.date.length > 0
        ) {
          const timeFrom = this.modelForm.date?.length
            ? this.moment(this.modelForm.date[0])
                .set({ hour: 0, minute: 0, second: 0 })
                .utcOffset("+07")
                .format()
            : "";
          const timeTo = this.modelForm.date?.length
            ? this.moment(this.modelForm.date[1])
                .set({ hour: 23, minute: 59, second: 59 })
                .utcOffset("+07")
                .format()
            : "";
          const searchDate = `date>=${timeFrom}_AND_date<=${timeTo}`;
          if (this.params.search) {
            this.params.search += `_AND_${searchDate}`;
          } else {
            this.params.search = `${searchDate}`;
          }
        }
        this.loadingDownload = true;
        logisticServices
          .getDownloadStockAdjustmentCogs(this.params)
          .then(response => {
            if (response) {
              const url = window.URL.createObjectURL(new Blob([response]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "stock_adjustment.xlsx"); //or any other extension
              document.body.appendChild(link);
              link.click();
            }
          })
          .finally(() => (this.loadingDownload = false));
      });
    },
    checkValue(value): string {
      if (value && !value.includes("undefined")) {
        return value;
      } else {
        return ",ALL";
      }
    },
    checkParams(res): string {
      let params = "";
      // company is mandatory
      params += this.$store.state.authStore.authData.companyName;
      params += this.checkValue(
        `,${
          this.dataStockAdjustment.find(dataFind => dataFind.id === res["no"])
            ?.documentNumber
        }`
      );
      params += this.checkValue(
        `,${
          this.dataBranch.find(dataFind => dataFind.id === res["branch"])?.name
        }`
      );
      params += this.checkValue(
        `,${this.dataListLocationWarehouse
          .find(dataFind => dataFind.id === res["warehouse"])
          ?.name?.replace(",", "")}`
      );
      params += this.checkValue(
        `,${this.dataListLocationRack
          .find(dataFind => dataFind.id === res["rack"])
          ?.name?.replace(",", "")}`
      );
      params += this.checkValue(`,${res["adj"]}`);
      // date from & date to
      params += this.checkValue(
        this.modelForm.date.length > 0
          ? `,${moment(this.modelForm.date[0])
              .set({ hour: 0, minute: 0, second: 0 })
              .utcOffset("+07")
              .format("DD-MM-yyyy HH:MM:ss")}`
          : ",ALL"
      );
      params += this.checkValue(
        this.modelForm.date.length > 0
          ? `,${moment(this.modelForm.date[1])
              .set({ hour: 23, minute: 59, second: 59 })
              .utcOffset("+07")
              .format("DD-MM-yyyy HH:MM:ss")}`
          : ",ALL"
      );

      return params;
    },
    handlePrint() {
      this.form.validateFields((err, res) => {
        if (err) return;
        // set params
        this.params.params = this.checkParams(res);
        // set search
        this.params.search = this.dynamicSearch(res);
        if (
          this.modelForm.date &&
          Array.isArray(this.modelForm.date) &&
          this.modelForm.date.length > 0
        ) {
          const timeFrom = this.modelForm.date?.length
            ? this.moment(this.modelForm.date[0])
                .set({ hour: 0, minute: 0, second: 0 })
                .utcOffset("+07")
                .format()
            : "";
          const timeTo = this.modelForm.date?.length
            ? this.moment(this.modelForm.date[1])
                .set({ hour: 23, minute: 59, second: 59 })
                .utcOffset("+07")
                .format()
            : "";
          const searchDate = `date>=${timeFrom}_AND_date<=${timeTo}`;
          if (this.params.search) {
            this.params.search += `_AND_${searchDate}`;
          } else {
            this.params.search = `${searchDate}`;
          }
        }
        this.loadingPrint = true;

        logisticServices
          .getPrintStockAdjustmentCogs(this.params)
          .then(response => {
            if (response) {
              const url = window.URL.createObjectURL(new Blob([response]));
              printJs(url);
            }
          })
          .finally(() => (this.loadingPrint = false));
      });
    },
    onRangePickerChange(dates: Array<any>): void {
      if (!dates.length) {
        this.modelForm.date = undefined;
      }
    },
    responsePageSizeChange(response: ResponsePagination) {
      this.limit = response.size;
      this.page = 1;
      this.onSubmit();
    },
    responseCurrentPageChange(response: ResponsePagination) {
      this.page = response.page;
      this.onSubmit();
    },
    handleCancel() {
      this.tableValueOpname = [];
      this.tableValueAdjustment = [];
      this.modelForm.date = [];
      this.form.resetFields();
    },
    disabledDate(current) {
      return current > moment().endOf("day");
    },
    handleSelectType(value: string): void {
      this.form.setFieldsValue({
        adj: value,
      });
    },
    dynamicSearch(res): string {
      const builder = new SearchBuilder();
      const query: string[] = [];
      if (res.no) query.push(builder.push(["secureId", res.no]).build());
      if (res.branch)
        query.push(
          builder.push(["branchWarehouse.secureId", res.branch]).build()
        );
      if (res.warehouse)
        query.push(
          builder.push(["warehouse.secureId", res.warehouse]).build()
        );
      if (res.adj)
        query.push(
          builder
            .push(["type", res.adj.replace(" ", "_").toUpperCase()])
            .build()
        );
      if (
        this.modelForm.date &&
        Array.isArray(this.modelForm.date) &&
        this.modelForm.date.length > 0
      ) {
        const timeFrom = this.moment(this.modelForm.date[0])
          .set({ hour: 0, minute: 0, second: 0 })
          .utcOffset("+07")
          .format();
        const timeTo = this.moment(this.modelForm.date[1])
          .set({ hour: 23, minute: 59, second: 59 })
          .utcOffset("+07")
          .format();
        query.push(builder.push(["date", timeFrom], { het: true }).build());
        query.push(builder.push(["date", timeTo], { let: true }).build());
      }
      return query.join(builder.AND);
    },
    async onSubmit(): Promise<void> {
      try {
        this.form.validateFields((err, res) => {
          if (err) return;
          const params: RequestQueryParamsModel = {
            page: this.page - 1,
            limit: this.limit,
            sorts: "date:desc",
          };
          params.search = this.dynamicSearch(res);
          if (params.search) params.search += "_AND_state~SUBMITTED";
          else params.search = "state~SUBMITTED";
          this.loadingTable = true;
          debounce(() => {
            logisticServices
              .getStockAdjustment(params)
              .then(data => {
                data.data.forEach((dataMap, index) => {
                  dataMap.key = index;
                  dataMap.date = dataMap.date
                    ? moment(dataMap.date).format("DD MMM yyyy")
                    : "";
                });
                this.dataSource = data.data;
                this.totalElements = data.totalElements;
              })
              .finally(() => (this.loadingTable = false));
          }, 500);
        });
      } catch (error) {
        this.$message.error(Messages.CREATE_FAIL);
      }
    },
    handleBranch(value) {
      this.branchId = value;
      this.form.resetFields(["warehouse", "rack"]);
      this.getListWarehouse("", this.branchId);
    },
    handleChangeWarehouse(id) {
      this.idWarehouse = id;
      this.form.resetFields(["rack"]);
    },
    handleStockAdjustment(value) {
      this.stockAdjustmentId = value;
    },
    getStockAdjustment(search) {
      const params: RequestQueryParamsModel = {
        page: 0,
        limit: 10,
      };
      if (search) params.search = `documentNumber~*${search}*`;

      this.loadingNo = true;
      logisticServices
        .getStockAdjustment(params)
        .then(data => {
          data.data.forEach((dataMap, index) => {
            dataMap.key = index;
          });
          this.dataStockAdjustment = data.data;
        })
        .finally(() => (this.loadingNo = false));
    },
    getBranch(valueSearch) {
      const params: RequestQueryParamsModel = {
        page: 0,
        limit: 10,
      };
      if (valueSearch)
        params.search = `name~*${valueSearch}*_OR_code~*${valueSearch}*_OR_address~*${valueSearch}`;
      this.loadingBranch = true;
      logisticServices
        .listWarehouseBranch(params, "")
        .then(response => {
          this.dataBranch = response.data;
        })
        .finally(() => (this.loadingBranch = false));
    },
    getListWarehouse(valueSearch, id) {
      if (id) {
        let params = {
          page: 0,
          limit: 10,
          search: `branchWarehouse.secureId~${id}`,
        } as RequestQueryParamsModel;
        if (valueSearch) params.search += `_AND_name~*${valueSearch}*`;
        this.loadingLocationWarehouse = true;
        logisticServices
          .listWarehouse(params, "")
          .then(data => {
            this.dataListLocationWarehouse = data.data;
          })
          .finally(() => (this.loadingLocationWarehouse = false));
      } else {
        this.$notification.error({
          message: "Error",
          description: "Choose Location Branch first to get list warehouse",
        });
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].componentOptions.children[1].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  computed: {
    formItemLayout() {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
      };
    },
  },
  created() {
    this.getBranch("");
    this.getStockAdjustment("");
  },
});
